import { Component, Input } from "@angular/core";
import { savingButtonAnimation } from "@app/animations";

@Component({
  selector: "submit-button",
  templateUrl: "./submit-button.component.html",
  animations: [savingButtonAnimation],
})
export class SubmitButtonComponent {
  public NO_STATUS: string = "";
  public SAVING_STATUS: string = "saving";
  public SAVED_STATUS: string = "saved";
  public FAILED_STATUS: string = "failed";

  @Input()
  public label: string = "Save";
  @Input()
  public savingLabel: string = "Saving";
  @Input()
  public savedLabel: string = "Saved";
  @Input()
  public errorLabel: string = "Saved failed. Please retry.";
  @Input()
  disabled: boolean = true;
  @Input()
  public additionalClass: string;

  public _status: string = this.NO_STATUS;

  get status() {
    return this._status;
  }

  @Input()
  set status(status: string) {
    this._status = status;

    if (
      this._status === this.SAVED_STATUS ||
      this._status === this.FAILED_STATUS
    ) {
      this.reinitSubmitButton();
    }
  }

  private reinitSubmitButton() {
    setTimeout(() => {
      this._status = this.NO_STATUS;
    }, 2000);
  }
}
